module.exports = "<ol ng-if=$root.user class=breadcrumb> <li ng-repeat=\"crumb in breadcrumbs\" ng-class=\"{ active: $last }\"> <a ui-sref={{crumb.route}} ng-if=!$last>{{ crumb.displayName }}&nbsp;</a> <span ng-show=$last>{{ crumb.displayName }}</span> </li> </ol>";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp-files/modules/app/components/breadcrumbs/breadcrumbs.directive.html
// module id = 373
// module chunks = 0